import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from '../../shared/services/auth.guard';
import { PermissionsGuardService } from '../../shared/services/permissions-guard.service';
import { AdminDashboardComponent } from './admin-dashboard/admin-dashboard.component';
import { UpdatePasswordComponent } from './update-password/update-password.component';

const adminRoutes: Routes = [
  {
    path: 'dashboard',
    component: AdminDashboardComponent,
    canActivate:[PermissionsGuardService]
  },
  {
    path: 'reports',
    loadChildren: () => import('./report/report.module').then(m => m.ReportModule),
    canActivate: [PermissionsGuardService, AuthGuardService]
  },
  {
    path: 'requests',
    loadChildren: () => import('./request/request.module').then(m => m.RequestModule),
    canActivate: [PermissionsGuardService, AuthGuardService]
  },
  {
    path: 'actions',
    canActivate: [AuthGuardService],
    loadChildren: () => import('./action/action.module').then(m => m.ActionModule),
  },
  {
    path: 'update-password',
    component: UpdatePasswordComponent,
    canActivate: [AuthGuardService]
  },
];

@NgModule({
  imports: [RouterModule.forChild(adminRoutes)],
  exports: [RouterModule]
})
export class AdminRoutingModule { }
